import { useRegionsQuery, RegionsQuery } from "@apollo/gen/generatedOperations";

export const useRegions = (): RegionsQuery | undefined => {
  const { data } = useRegionsQuery();
  return data;
};
